import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/FAQ.css";
import InnerPageHeader from "./InnerPageHeader";
import HomepageButton from "./HomepageButton";
import Footer from "./Footer";

export default function FAQ() {
  const { t } = useTranslation("faq");
  const { t: tc } = useTranslation("common");
  const [activeIndex, setActiveIndex] = useState(null);

  const items = t("items", { returnObjects: true });

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <InnerPageHeader
        title={t("title")}
        subtitle={t("subtitle")}
      />

      <section className="faq-container">
        <div className="faq-list">
          {items.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
            >
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <div className="faq-back">
        <HomepageButton label={tc("back")} href="/#homepage" />
      </div>

      <Footer />
    </>
  );
}
